import api from './client';

const get = (url, params) => api.get(url, { params }).then((r) => r.data);

export const monitor = {
  overview: () => get('/monitor/overview').then((r) => r.data),
  fields: () => get('/monitor/fields').then((r) => r.data),
  field: (id) => get(`/monitor/fields/${id}`).then((r) => r.data),
  stations: () => get('/monitor/stations').then((r) => r.data),
  station: (id) => get(`/monitor/stations/${id}`).then((r) => r.data),
  series: (stations, range) => get('/monitor/series', { stations: [].concat(stations).join(','), range }).then((r) => r.data),
  alerts: (params) => get('/monitor/alerts', params),
  ackAlert: (id) => api.patch(`/monitor/alerts/${id}/ack`).then((r) => r.data),
  resolveAlert: (id) => api.patch(`/monitor/alerts/${id}/resolve`).then((r) => r.data),
  ackAll: () => api.post('/monitor/alerts/ack-all').then((r) => r.data),
  readings: (params) => get('/monitor/readings', params),
  analytics: (days) => get('/monitor/analytics', { days }).then((r) => r.data),
  system: () => get('/monitor/system').then((r) => r.data),
  simulator: () => get('/monitor/simulator').then((r) => r.data),
  simulatorControl: (body) => api.post('/monitor/simulator', body).then((r) => r.data.data),
  thresholds: (id, body) => api.patch(`/monitor/stations/${id}/thresholds`, body).then((r) => r.data),
  csv: (params) => api.get('/monitor/readings', { params: { ...params, format: 'csv' }, responseType: 'text' }).then((r) => r.data),
  sendReading: (deviceName, data) => api.post('/users/devices/stream', { deviceName, data }),
};
export const authApi = {
  login: (email, password) => api.post('/users/authenticate', { email, password }).then((r) => r.data),
  me: () => api.get('/users/me').then((r) => r.data.data.user),
  users: () => api.get('/users', { params: { limit: 100 } }).then((r) => r.data.data),
};
